<template>
  <div class="about-section_block">
    <h3 class="large_blue_label">即時・オンデマンド・柔軟 ― immediate / on demand / flexible ―</h3>
    <p>私は10年間ほど建築物の構造設計者として仕事をしてきました。</p>
    <p>
      とある日の仕事中、図面に変更が生じたので手元にある図面に赤ペンで変更点を描き入れました。ちょうどその時はCAD作図をお願いしていたオペレーターさんとの契約が切れてしまっていたので、さて誰にCADデータの修正をお願いしようかと考えた時、ふと思いました。</p>
    <p>24時間365日いつでも自分に付き添って仕事を請けてくれるオペレーターさんがいれば、どれだけ仕事がはかどることか……。</p>
    <p>日本中探せば今この瞬間に仕事をしたいけど暇を持て余しているオペレーターさんや構造設計者もいるだろう。いや、日本にいなかったとしても地球上のどこかには……。</p>
    <p>そんな妄想からこの計画は始まりました。</p>
    <br>
    <p>設計者、エンジニアがオペレーターを探したり、見積もりを取って契約を交わす手間は意外と大きいものです。</p>
    <p>まして数時間で終わるような少ない作業量の場合は外に出すのを諦めて自ら作業を行ったり、後輩に頼んだりと……。</p>
    <p>では頼まれた後輩はどうなるか？</p>
    <p>たとえ社内にオペレーターがいたとしても突発的に生じた作業をすぐにやってくれるとは限りませんので、往々にして調整が必要になります。</p>
    <p>こういった発注手間やタイムラグから解放され、仕事を頼みたいと思った時に適切な人材にすぐに頼むことができれば、本来やるべき設計業務により集中でき、生産性が高まることに疑念の余地はありません。</p>
    <br>
    <p>一方でオペレーターの方はどうでしょうか。</p>
    <p>設計者から出てくるはずだった作図指示が延期された。業務が急に中断した。</p>
    <p>といった理由でせっかく出勤したその日を無駄に過ごしたという経験はありませんか？</p>
    <p>または育児休業中や暇な休日に自宅でスポットで仕事をしたい、という方もたくさんいるのではないでしょうか？</p><br>
    <p>それとは逆に短期間で大量の作図をしなければならないときに、そのうちの比較的簡易な作業を余裕がある別の人に頼むということもあるかと思います。</p>
    <p>こういった業務の平準化は大きな事務所の中では日常的に行われていますが、小規模な事務所や個人ではできません。</p>
    <br>
    <p>仮に、会社や事務所といった境界を越えて日本全体がひとつの組織のようになり、仕事をすぐ頼める、請けられる環境があれば誰でも業務の平準化ができるようになります。</p>
    <br>
    <p>フルーは上記したような設計者とオペレーター、両者のニーズを結びつけるサービスを目指しています。</p>
    <br>
    <br>
    <h3 class="large_blue_label">余白をつくる ― create X ―</h3>
    <p>では上で述べたようなサービスが実現した結果どのようなメリットがもたらされるのか？</p>
    <p>「生産性」という言葉を上で用いましたが、ただそれだけが目的では再生産と効率化を推し進め、サービス利用者に何のメリットももたらさない危険性をはらんでいます。</p>
    <br>
    <p>ここで、私が目指す真のメリットは利用者のみなさまに「ゆとり」を生み出してもらうことだと考えています。</p>
    <p>「ゆとり」があると目の前に直面している事象から離れて新しい学びや、趣味・政治・経済・コミュニティなどについて考えたり、行動を起こすことができるようになります。</p>
    <br>
    <p>
      私はこの「ゆとり」を「余白」という言葉に置き換えています。思いついたものを自由に描くことができる空白です。日々デザイン業務に関わる私たちにとっては「余白」という言葉の方がしっくりくるかと思い、この言葉を使うことにしました。</p>
    <br>
    <p>この「余白」は時間であったりお金であったりします。</p>
    <p>フルーを利用頂く方が新しい余白を手に入れ、それを使うことで人生がより豊かになったり、イノベーションを生み出したりできれば、私にとってもこの上ない幸せです。</p>
    <p>余白の使い方まではフルーの力の及ばない範囲ですので、ぜひそのようなことを意識してサービスを利用頂ければ幸いです。</p>
    <br>
    <p>フルーはまだまだシステムの面でもユーザー数の面でも発展途上です。今後みなさまの声を受け止め、掲げた目標に向かって邁進していく所存でおりますので、何卒よろしくお願い申し上げます。</p>

    <div>
      <div class="left">
        <img class='base_image' src='@/assets/image/pages/information/about/profile.jpg'/>
      </div>
      <div class="right">
        代表取締役 矢野 貴大
        <a href="https://twitter.com/yano_tak" target="_blank" >
          <img class='base_image' src='@/assets/image/pages/information/about/twitter.png'/>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AboutSectionBlock"
  }
</script>

<style lang="scss" scoped>
  .about-section_block {
    > .large_blue_label {
      margin-bottom: 2rem;
    }
    > div {
      margin-top: 8rem;
      @include double_columns(40%, 40%);

      > .left {
        display: flex;
        justify-content: flex-end;
        > .base_image {
          width: 15rem;
        }
      }
      > .right {
        display: flex;
        align-items: flex-end;
        > a > .base_image {
          margin-left: 2rem;
          width: 30px;
        }
      }
    }

    @media screen and (max-width: 767px) {
      > div {
        > .left {
          justify-content: center;
          > .base_image {
            width: 50%;
            max-height: 25rem;
          }
        }
        > .right {
          justify-content: center;
        }
      }
    }
  }
</style>